import { Component, OnInit } from '@angular/core';
import { ControlVehiculosService } from 'src/app/services/admin/control-vehiculos-service/control-vehiculos.service';
import { Gtp } from 'src/app/shared/gtp';

@Component({
  selector: 'app-control-vehiculos-movimiento',
  templateUrl: './control-vehiculos-movimiento.component.html',
  styleUrls: ['./control-vehiculos-movimiento.component.scss']
})
export class ControlVehiculosMovimiento implements OnInit {
  
  loading:boolean = false;
  public contClass: string = 'container-fluid maincont';
  fechalang: any;
  
  public intervaloNotif = null;
  public sinidentificacion = null;
  public defaultDate: Date;
  
  public rangohoras = {
    lunes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    martes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    miercoles: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    jueves: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    viernes: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    sabado: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
    domingo: {
      desde: {
        primero: null,
        segundo: null
      },
      hasta: {
        primero: null,
        segundo: null
      },
    },
  };

  public perfilData = {};

  constructor(
    public gtp: Gtp,
    private ctrlVehiculo: ControlVehiculosService,
  ) {
    this.fechalang = this.gtp.fechalang;  
    this.defaultDate = this.gtp.setHoras(0, 0, 0);
  }
  
  ngOnInit(): void {
    //console.log(this.ctrlVehiculo.MovimientoConfig.length, this.ctrlVehiculo.MovimientoConfig);
    if (this.ctrlVehiculo.MovimientoConfig.length>0) {
      this.setInitialInfo();
    }
  }

  setInitialInfo(){
    //Set Intervalo Notificaciones
    this.intervaloNotif = this.ctrlVehiculo.MovimientoConfig.intervalonotif;
    this.sinidentificacion = this.ctrlVehiculo.MovimientoConfig.sinidentificacion;
    //Primero
    this.rangohoras.lunes.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.lunes.desde.primero);
    this.rangohoras.lunes.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.lunes.hasta.primero);
    this.rangohoras.martes.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.martes.desde.primero);
    this.rangohoras.martes.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.martes.hasta.primero);
    this.rangohoras.miercoles.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.miercoles.desde.primero);
    this.rangohoras.miercoles.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.miercoles.hasta.primero);
    this.rangohoras.jueves.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.jueves.desde.primero);
    this.rangohoras.jueves.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.jueves.hasta.primero);
    this.rangohoras.viernes.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.viernes.desde.primero);
    this.rangohoras.viernes.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.viernes.hasta.primero);
    this.rangohoras.sabado.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.sabado.desde.primero);
    this.rangohoras.sabado.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.sabado.hasta.primero);
    this.rangohoras.domingo.desde.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.domingo.desde.primero);
    this.rangohoras.domingo.hasta.primero = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.domingo.hasta.primero);
    //Segundo
    this.rangohoras.lunes.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.lunes.desde.segundo);
    this.rangohoras.lunes.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.lunes.hasta.segundo);
    this.rangohoras.martes.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.martes.desde.segundo);
    this.rangohoras.martes.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.martes.hasta.segundo);
    this.rangohoras.miercoles.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.miercoles.desde.segundo);
    this.rangohoras.miercoles.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.miercoles.hasta.segundo);
    this.rangohoras.jueves.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.jueves.desde.segundo);
    this.rangohoras.jueves.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.jueves.hasta.segundo);
    this.rangohoras.viernes.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.viernes.desde.segundo);
    this.rangohoras.viernes.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.viernes.hasta.segundo);
    this.rangohoras.sabado.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.sabado.desde.segundo);
    this.rangohoras.sabado.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.sabado.hasta.segundo);
    this.rangohoras.domingo.desde.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.domingo.desde.segundo);
    this.rangohoras.domingo.hasta.segundo = this.formatRango(this.ctrlVehiculo.MovimientoConfig.rangohoras.domingo.hasta.segundo);
  }

  formatRango(hora) {
    let dia = this.gtp.getDay(new Date()).split('/');
    let fecha = `${dia[2]}/${dia[1]}/${dia[0]} ${hora}`;
    return this.gtp.String2Date(fecha);
  }

  /**
   * Cierra la ventana del informe activa.
   */
  cerrarInforme() {
    this.gtp.cerrarVentanas(true);
  }

  /**
   * Aumenta o disminuye el tamaño del ancho en el informe.
   */
  containerSize() {
    this.contClass = this.gtp.containerSize(this.contClass);
  }

  saveParams(){    
    this.perfilData = {
      rangohoras: this.parseRangoHoras(this.rangohoras),
      intervalonotif: (this.intervaloNotif) ? this.intervaloNotif : false,
      sinidentificacion: (this.sinidentificacion) ? this.sinidentificacion : false,
    };
    this.perfilData = JSON.parse(JSON.stringify(this.perfilData));
    this.ctrlVehiculo.setMovimientoConfig(this.perfilData);
    //console.log('Actualizando...');
  }

  parseRangoHoras(rangohoras) {
    return {
      lunes: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.lunes.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.lunes.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.lunes.desde.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.lunes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.lunes.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.lunes.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.lunes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.lunes.hasta.segundo) : null,
        }
      },
      martes: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.martes.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.martes.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.martes.desde.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.martes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.martes.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.martes.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.martes.hasta.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.martes.hasta.segundo) : null,
        }
      },
      miercoles: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.miercoles.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.miercoles.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.miercoles.desde.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.miercoles.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.miercoles.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.miercoles.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.miercoles.hasta.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.miercoles.hasta.segundo) : null,
        }
      },
      jueves: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.jueves.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.jueves.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.jueves.desde.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.jueves.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.lunes.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.jueves.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.jueves.hasta.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.jueves.hasta.segundo) : null,
        }
      },
      viernes: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.viernes.desde.primero )) ? this.gtp.getHourMinuteSecond(rangohoras.viernes.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.viernes.desde.segundo )) ? this.gtp.getHourMinuteSecond(rangohoras.viernes.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.viernes.desde.primero )) ? this.gtp.getHourMinuteSecond(rangohoras.viernes.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.viernes.hasta.segundo )) ? this.gtp.getHourMinuteSecond(rangohoras.viernes.hasta.segundo) : null,
        }
      },
      sabado: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.sabado.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.sabado.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.sabado.desde.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.sabado.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.sabado.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.sabado.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.sabado.hasta.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.sabado.hasta.segundo) : null,
        }
      },
      domingo: {
        desde: {
          primero: (this.gtp.validDate(rangohoras.domingo.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.domingo.desde.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.domingo.desde.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.domingo.desde.segundo) : null,
        },
        hasta: {
          primero: (this.gtp.validDate(rangohoras.domingo.desde.primero)) ? this.gtp.getHourMinuteSecond(rangohoras.domingo.hasta.primero) : null,
          segundo: (this.gtp.validDate(rangohoras.domingo.hasta.segundo)) ? this.gtp.getHourMinuteSecond(rangohoras.domingo.hasta.segundo) : null,
        }
      }
    };
  }

}
